export const ACTUALIZAR_SUBCUENTAS = "ACTUALIZAR_SUBCUENTAS";
export const ACTUALIZAR_DIMENSIONES = "ACTUALIZAR_DIMENSIONES";
export const ACTUALIZAR_SUBCUENTAS_DB = "ACTUALIZAR_SUBCUENTAS_DB";
export const CARGANDO_SUBCUE = "CARGANDO_SUBCUE";
export const ERROR_SUBCUE = "ERROR_SUBCUE";
export const LIMPIAR_ERROR = "LIMPIAR_ERROR";